/** Shared validation for ZIP / City / Sponsor date-range searches. */

export function isDateRangeSearchValid(startDate, endDate) {
  if (!startDate) return false
  if (!endDate) return true
  const start = new Date(startDate).setHours(0, 0, 0, 0)
  const end = new Date(endDate).setHours(0, 0, 0, 0)
  return end >= start
}

/** True when search has a start date but no end date (open-ended / infinite-scroll mode). */
export function isOpenEndedDateRangeSearch(startDate, endDate) {
  return !!startDate && !endDate
}

export default isDateRangeSearchValid
